<script setup>
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useTrackingPage } from "@/mixins/tracking/all-pages";
import { useClientStore } from "@/store/client";
import { useContextStore } from "@/store/context";
import { useMagasinStore } from "@/store/magasin";

definePageMeta({
  middleware: "authenticated"
});

const { trackPage } = useTrackingPage();

const { layout } = storeToRefs(useContextStore());

const { isNational } = storeToRefs(useMagasinStore());

const {
  client,
  adressesLad,
  defaultAdress,
  otherAddresses,
  adressesDetails,
  isPro
} = storeToRefs(useClientStore());

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[
      `/components/pages/mon-compte/mes-adresses/${layout.value}.vue`
    ]
  );
});

onMounted(() => {
  trackPage(trackingCodes.PAGETYPE.monCompte);
});

const { fetchAddresses } = useClientStore();

await useAsyncData(() => fetchAddresses());
</script>

<template>
  <component
    :is="component"
    :default-address="defaultAdress"
    :adresses-details="adressesDetails"
    :adresses-lad="adressesLad"
    :client="client"
    :is-pro="isPro"
    :is-national="isNational"
    :other-addresses="otherAddresses"
    @fetchAddresses="fetchAddresses"
  />
</template>
